/**
 * Territories where analytics requires OPT-IN.
 *
 * The EEA (EU 27 + Iceland, Liechtenstein, Norway) under GDPR/ePrivacy, plus
 * the UK (UK GDPR) and Switzerland (revFADP). Everywhere else `analytics_storage`
 * defaults to `granted` and the banner acts as an opt-OUT notice.
 *
 * This list IS the whole geo implementation. Google resolves `region` from the
 * request IP inside gtag, so there is no client-side lookup to get wrong, no
 * extra request, and no race with the consent default it scopes.
 *
 * `ad_*` is deliberately absent: advertising consent stays opt-in worldwide,
 * matching the LinkedIn Insight tag being opt-in in the Klaro config on w-z.com.
 *
 * Duplicated in wz-cms-astro/src/lib/consent-regions.ts.
 * The two MUST agree — a visitor who crosses from w-z.com into the app would
 * otherwise get one answer on each side of the same session.
 */
export const CONSENT_OPT_IN_REGIONS = [
  // EU 27
  'AT', 'BE', 'BG', 'CY', 'CZ', 'DE', 'DK', 'EE', 'ES', 'FI',
  'FR', 'GR', 'HR', 'HU', 'IE', 'IT', 'LT', 'LU', 'LV', 'MT',
  'NL', 'PL', 'PT', 'RO', 'SE', 'SI', 'SK',
  // EEA, non-EU
  'IS', 'LI', 'NO',
  // UK GDPR + Swiss revFADP
  'GB', 'CH',
] as const;
